import { createContext } from 'react';
import { Project } from '../const';

export const ProjectContext = createContext<{ project: Project }>({
  project: Project.Website,
});
